//cn.js
import en from './en'
const cn = {
  headerTitle:'大连毅都集团有限公司',
  // 菜单
  menu: [{
    level1: '首页',
    name:'Home',
  },{
    level1: '关于毅都',
    name:'About',
    detailTitle:{
      cn:'关于毅都',
      en:'ABOUT YIDU'
    },
    list1: [{
      level2:'毅都概览',
      name:'GeneralIntroduction'
    },{
      level2:'企业文化',
      name:'Culture'
    },{
      level2:'资质荣誉',
      name:'Honor'
    },{
      level2:'发展历程',
      name:'History'
    },{
      level2:'企业视频',
      name:'YIDUVideo'
    }]
  },{
    level1: '毅都资讯',
    name:'PressCenter',
    detailTitle:{
      cn:'毅都资讯',
      en:'PRESS CENTER'
    },
    list1:[{
      level2:'毅都新闻',
      name:'YIDUEvents'
    },{
      level2:'行业新闻',
      name:'IndustryNews'
    },{
      level2:'企业内刊',
      name:'EnterpriseJournal'
    }]
  },{
    level1: '业务涵盖',
    name:'BusinessLine',
    detailTitle:{
      cn:'业务涵盖',
      en:'BUSINESS LINE'
    },
    list1:[{
      level2:'进出口贸易',
      name:'ImportAndExportTrade',
      list2:[{
        level3:'产地直采',
        name:'SelectFromSource',
      },{
        level3:'国内销售',
        name:'DomesticSales',
      }],
    },{
      level2:'冷链物流',
      name:'ColdChainLogistics',
      list2:[{
        level3:'水产冷链服务中心',
        name:'SeafoodColdChianBU',
      },{
        level3:'肉类服务中心',
        name:'MeatServiceBU',
      },{
        level3:'水果交易中心',
        name:'FruitTradingServiceBU',
      },{
        level3:'供应链服务中心',
        name:'SupplyChainServices',
      },{
        level3:'运输业务中心',
        name:'DistributionServices',
      },{
        level3:'冷藏箱技术服务',
        name:'RefrigeratedBoxTechnicalServices',
      },{
        level3:'供应链金融',
        name:'SupplyChainFinancialServices',
      },{
        level3:'全国布局',
        name:'NationalLayouts',
      }],
    },{
      level2:'生态农业',
      name:'EcologicalAgricultures',
      list2:[{
        level3:'产业介绍',
        name:'IndustryIntroduction',
      },{
        level3:'基地概况',
        name:'BaseProfile',
      }],
    }]
  },{
    level1: '加入毅都',
    name:'JoinYIDU',
    detailTitle:{
      cn:'加入毅都',
      en:'JOIN YIDU'
    },
    list1:[{
      level2:'校园招聘',
      name:'CampusRecruitment',
      list2:[{
        level3:'管培生项目',
        name:'ManagementTraineeProgram',
      },{
        level3:'岗位介绍',
        name:'JobDescription',
      },{
        level3:'校招流程',
        name:'CampusRecruitmentProcess',
      }],
    },{
      level2:'社会招聘',
      name:'SocialRecruitment'
    },{
      level2:'TA在毅都',
      name:'YIDUPeople'
    }]
  },{
    level1: '联系我们',
    name:'ContactUs',
    detailTitle:{
      cn:'联系我们',
      en:'CONTACT US'
    },
    list1:[{
      level2:'联系我们',
      name:'ContactUs'
    }]
  }],

  //了解更多
  more:'了解更多',

  //主要板块1
  mainPlate1: [{
     title:'进出口贸易',
     titleEN:'IMPORT AND EXPORT TRADE',
     name:'ImportAndExportTrade',
     path:'/Detail/BusinessLine/ImportAndExportTrade/SelectFromSource',
     describe1:'主营生鲜经营业务，用严格的质量标准、专业化的经营团队，从全球采购优质农产品，生鲜销售网络覆盖全国；',
     describe2:'开展生态农业业务，引进国际优质生鲜种苗，带动农民就业增收。',
     content:[{
       bg1:"background:url("+ require('@/assets/images/进出口-营销网络1.png') + ") center center no-repeat;",
       bg2:"background:url("+ require('@/assets/images/进出口-营销网络2.png') + ") center center no-repeat;",
       switch:'true',
       detailPage:'产地直采',
       name:'SelectFromSource'
     },{
       bg1:"background:url("+ require('@/assets/images/进出口-直营档口1.png') + ") center center no-repeat;",
       bg2:"background:url("+ require('@/assets/images/进出口-直营档口2.png') + ") center center no-repeat;",
       switch:'true',
       detailPage:'国内销售',
       name:'DomesticSales'
     }
     // ,{
     //   bg1:"background:url("+ require('@/assets/images/进出口-超市促销1.png') + ") center center no-repeat;",
     //   bg2:"background:url("+ require('@/assets/images/进出口-超市促销2.png') + ") center center no-repeat;",
     //   switch:'true',
     //   detailPage:'生态农业',
     //   name:'EcologicalAgriculture'
     // },{
     //   bg1:"background:url("+ require('@/assets/images/进出口-珍享品牌1.png') + ") center center no-repeat;",
     //   bg2:"background:url("+ require('@/assets/images/进出口-珍享品牌2.png') + ") center center no-repeat;",
     //   switch:'true',
     //   detailPage:'产品展示',
     //   name:'ProductDisplay'
     // }
     ]
  },{
     title:'冷链物流',
     titleEN:'COLD CHAIN LOGISTICS',
     name:'ColdChainLogistics',
     path:'/Detail/BusinessLine/ColdChainLogistics/SeafoodColdChianBU',
     describe1:'以规模化的冷链物流设施为基础，以功能完善的信息化平台为工具，以专业的冷链运营团队为核心，利用金融服务为杠杆，让生产者与消费者无缝连接，将自身打造成进口生鲜食品供应链最佳服务商。',
     // describe2:'开展生态农业业务，引进国际优质生鲜种苗，带动农民就业增收。',
     content:[{
        bg1:"background:url("+ require('@/assets/images/冷链物流-一期仓储1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/冷链物流-一期仓储2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'水果交易中心',
        name:'FruitTradingServiceBU'
     },{
        bg1:"background:url("+ require('@/assets/images/冷链物流-二期仓储1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/冷链物流-二期仓储2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'运输业务中心',
        name:'DistributionServices'
     },{
        bg1:"background:url("+ require('@/assets/images/冷链物流-拆提物流1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/冷链物流-拆提物流2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'供应链金融',
        name:'SupplyChainFinancialServices'
     },{
        bg1:"background:url("+ require('@/assets/images/冷链物流-重箱堆场1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/冷链物流-重箱堆场2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'全国布局',
        name:'NationalLayouts'
     }]
  }, {
      title:'生态农业',
      titleEN:'ECOLOGICAL AGRICULTURE',
      name:'EcologicalAgriculture',
      describe1:'专业培植技术，专注农产品研发，专心为市场服务。',
      content:[{
        bg1:"background:url("+ require('@/assets/images/生态农业-基地概况1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/生态农业-基地概况2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'基地概况',
        name:'BaseProfile'
      },{
        bg1:"background:url("+ require('@/assets/images/生态农业-蓝莓介绍1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/生态农业-蓝莓介绍2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'蓝莓介绍'
      },{
        bg1:"background:url("+ require('@/assets/images/生态农业-种苗销售1.png') + ") center 0 no-repeat;",
        bg2:"background:url("+ require('@/assets/images/生态农业-种苗销售2.png') + ") center 0 no-repeat;",
        switch:'true',
        detailPage:'种苗销售'
      }]
  }
  ],
  //主要板块2
  mainPlate2: [{
    title:'毅都概览',
    bgImg1:"background:url("+ require('@/assets/images/毅都概览-1.png') + ") center center no-repeat;",
    bgImg2:"background:url("+ require('@/assets/images/毅都概览-2.png') + ") center center no-repeat;",
    content:'毅都集团始创于1988年，现已形成了以东北、华北、华中、华南地区重要港口交通枢纽城市为中心，辐射全国市场的贸易格局，为全球优质生鲜产品进入中国市场，提供了高质量标准化的流通途径，通过构建完善的供应链上下游金融体系，实现对生鲜领域进行全产业链的业务覆盖。',
  },{
    title:'企业文化',
    bgImg1:"background:url("+ require('@/assets/images/企业文化-1.png') + ") center center no-repeat;",
    bgImg2:"background:url("+ require('@/assets/images/企业文化-2.png') + ") center center no-repeat;",
    content:'以规模化的冷链物流设施为基础，以完善的信息化平台为手段，以专业的冷链运营团队为核心，以现代的金融服务为杠杆，优化流通环节，成为进口生鲜食品供应链的最佳管理者。',
  },{
    title:'发展历程',
    bgImg1:"background:url("+ require('@/assets/images/发展历程-1.png') + ") center center no-repeat;",
    bgImg2:"background:url("+ require('@/assets/images/发展历程-2.png') + ") center center no-repeat;",
    content:'2010年，毅都集团 “爱思福”优质水果良种苗木繁育基地首次将自产优质蓝莓及种苗推向市场。1995年，毅都国际货运代理有限公司成立。1995年，大连长禾集装箱运输公司成立。1997年，大连毅都报关行成立。'

  }],
  //主要板块3
  mainPlate3: [],

  //detail
  position:'当前位置',
  contact:'联系我们',
  address:'辽宁省大连市保税物流园1号卡门左侧',

  //毅都概览
  GeneralIntroduction:{
    introduce:'毅都集团立足辽宁、布局全国、链接世界，打造集进口贸易、冷链物流、基地种植、品种开发、品牌运营、渠道分销为一体的生鲜食品供应链经营管理与服务体系。秉持“诚信、责任、共赢、创新”的价值观，历经多年发展，已成为生鲜食品供应链最佳管理者与服务商。',
    list:[{
      title:'进口贸易',
      subtitle: '生鲜食品供应链最佳管理者',
      describe:'秉承生鲜食品供应链最佳管理者的发展理念，对品质的把控贯穿整个供应链流程，经验丰富的专业团队，甄选源头、严格把关，精心挑选全球优质生鲜，建立规范的产品标准、全程冷链直采直达、一站式专业物流服务，以天然、营养、健康，留存生鲜原滋原味。'
    },{
      title:'冷链物流',
      subtitle: '生鲜食品供应链最佳服务商',
      describe:'聚焦“生鲜食品”全流程供应链服务，提供线上线下，极致与极智的物流服务、金融服务、交易服务、贸易服务，打造覆盖全类型物流枢纽的临空、临港、内陆口岸冷链物流体系，以分布在大连、沈阳、郑州、广州的港口冷库为基础，提供覆盖全国的高效率、低成本的冷链配送服务，为生鲜客户提供一站式冷链物流解决方案，用心打造优质领“鲜”生活。'
    }]
  },
  // 企业文化
  Culture: {
    introduce:'',
    list:[{
      title:'价值观',
      describe:['诚信·责任·共赢·创新']
    },{
      title:'使命',
      describe:['改善人们的生活质量']
    },{
      title:'愿景',
      describe:['进口贸易 | 生鲜食品供应链最佳管理者', '冷链物流 | 生鲜食品供应链最佳服务商']
    },{
      title:'战略',
      describe:[
        '以规模化冷链物流设施为基础',
        '以数字化信息系统为手段',
        '以专业化冷链运营团队为核心',
        '以供应链金融为赋能',
        '将生产者与消费者无缝衔接',
        '打造成本低、效率高的',
        '线上线下相结合的生鲜供应链服务平台'
      ]
    }]
  },
  // 资质荣誉
  Honor: [
    '2009年全国冷库企业排名第二十四位',
    '2010年度中国食品物流50强',
    '2010年度中国冷链物流百佳企业',
    '2011-2012年度中国食品流通冷链物流百佳服务商',
    '2011年度中国食品冷库标兵企业',
    '2012年中国仓储服务金牌企业',
    '2013年辽宁省现代物流示范企业',
    '2014年度中国冷链物流百强企业',
    '2015年获AAA级物流企业',
    '2015年中国仓储服务金牌企业',
    '2015年中国冷链物流百强企业',
    '2016年获三星级冷链物流企业',
    '2016年获中国冷链双年“金链奖”十佳仓储服务商',
    '2016年度中国冷链物流百强企业',
    '2017年度中国冷链物流百强企业',
    '2018年度中国冷库行业百强企业',
    '2017-2018中国冷链产业金链奖十佳冷库运营服务商',
    '2018年中国仓储服务金牌企业（复审）',
    '2019年获AAA级物流企业(复审)',
    '2019年获三星级物流企业（复审）',
    '2018年全国冷链仓储百强企业',
    '2018年度中国冷链物流百强企业',
    '2019年度中国冷链物流百强企业',
    '2019年全国冷链仓储百强企业',
    '2020年全国冷链运营创新企业',
    '2020年度中国冷链物流百强企业',
    '2020年全国冷链仓储百强企业',
    '2020年新冠肺炎疫情防控先进集体',
    '2021年获AAAA级物流企业(升级)',
    '2021年仓储服务金牌企业（复审）',
    '2022年获五星级冷链物流企业（升级）',
    '2022年获批国家骨干冷链物流基地'
  ],
  //毅都新闻
  YIDUNews: [
    {
      h1:'南美车厘子“快线”正式上线，全力推进智利车厘子东北亚分拨中心建设',
      date:'2023-01',
      day:'12',
      p:{
        //前言
        //二级标题与内容
        secondArticle: [
          {
            image: [
              require('@/assets/images/news/2023/0112/image1.jpeg')
            ],
            text: [
              '1月11日，随着“马士基蒂诺斯”轮靠泊大连港集装箱码头，辽港集团南美车厘子“快线”正式上线运营。这不仅代表毅都集团与马士基开启了全面合作新篇章，也标志着大连港南美直航季节性干线正式上线。大连港南美水果集散分拨服务能力进一步增强，业务辐射半径进一步扩大。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2023/0112/image2.jpeg')
            ],
            text: [
              '当日下午，辽港集团南美车厘子快线首航暨智利车厘子东北亚分拨中心合作签约仪式在大连集装箱码头有限公司举行，辽宁港口股份有限公司与智利水果出口商协会签署战略合作框架协议，双方约定共同推进智利车厘子东北亚分拨中心建设。',

              '大连市政府，辽宁省交通运输厅、商务厅、大连市交通运输局、商务局，市政府口岸办、保税区管委会、海关、海事、边检等单位领导，智利水果出口商协会及下属的樱桃委员会、国内代理商、电商平台分销商、航运经营人等行业代表共同见证航线开通和协议签署。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2023/0112/image3.jpeg')
            ],
            text: [
              '本次首航船舶“马士基蒂诺斯”轮于2022年12月20日从智利圣安东尼奥港出发，1月11日直达大连港大窑湾码头。大连港车厘子快线船期与南沙和香港相同，全程共计22天，较传统中转模式节省18天。本航次共搭载进口智利车厘子616 TEU，其中592 TEU车厘子将在大连港卸船后直接运抵东北、华北区域一级批发市场，实现了从农场到市场的一站式快捷冷链运输；另外24 TEU车厘子将经大连港中转运抵韩国。大连港已经形成了以港口为中心，业务辐射东北亚，西接欧洲及中东的海上中转通道。',

              '大连港作为东北地区对外经贸往来和开放合作的重要枢纽，近年来依托辽港集团内外部协同优势，加速融入“一带一路”倡议，高效助力大连东北亚国际航运中心、国际物流中心、辽宁自贸区、大连“两先区”建设，服务东北振兴发展。围绕辽港集团“打造世界一流强港”的目标，大连港充分发挥口岸区位优越、冷链物流服务网络完善和通关条件便利等优势，致力于将大连口岸打造成为冷链物流中心，并在进口水果分拨业务方面处于国内主要沿海港口领先水平。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2023/0112/image4.jpeg')
            ],
            text: [
              '依托于大连港进境水果航线、码头、场地通关优势，毅都、首农、佳农共同建设了东北亚香蕉交易中心，实现集疏港、查验、仓储、加工(催熟、分拣、打包)、交易、分拨、配送等全产业链一体化服务。交易中心采用国际先进的香蕉气熏催熟技术，货船到港后，15分钟可从码头直达储运加工中心，5天完成催熟出库，实现了青蕉在码头直接催熟、从码头直供超市的全新物流模式。',

              '毅都冷链始终以成为“生鲜食品供应链最佳服务商”为目标，未来将充分利用大连港成熟的码头、物流、支线、信息、内陆营销、航线营销等服务网络，发挥大连港水陆运输、铁路运输、环渤海中转网络等优势，整合社会资源，发挥“互联网+”优势，建设口岸冷链物流供应链平台、冷链电子商务平台、口岸冷链金融与贸易平台，完善冷链物流体系功能，为发展建设国际冷链中转基地建设奠定基础。'
            ]
          }
        ]
      }
    },
    {
      h1:'毅都联手多家货运包机公司直采车厘子 飞跃半个地球直达',
      date:'2022-11',
      day:'21',
      p:{
        //前言
        //二级标题与内容
        secondArticle: [
          {
            image: [
              require('@/assets/images/news/2022/1121/image1.jpeg')
            ],
            text: [
              '11月20日 凌晨2:00，一架载有105吨车厘子的世界最大包机货运公司阿特拉斯航空包机从智利出发顺利抵达浦东国际机场。这是毅都今年第二架抵达的车厘子包机，早在11月17日，第一批智利直采车厘子包机就已顺利降落在郑州国际机场。这也正式拉开了毅都年末进口车厘子狂欢季的序幕。',

              '受国际疫情影响，外贸业务发展压力巨大，毅都集团面对疫情下运输、清关等各方面的不确定性，提前预案、灵活应对，多渠道多区域布局产品销售策略。各地机场海关也给予充分支持，优化作业流程，克服国际航班疫情防控保障诸多因素，切实提高通关时效，全力保障进口车厘子安全、快速通关。',

              '自2013年开展包机业务以来，毅都已连续多年从智利、美国包机直采车厘子。毅都是国内首家采用洲际水果包机业务模式的公司，如今包机直采已成为行业常态。今年是疫情后毅都再次恢复包整机直采直达车厘子业务。近期毅都还将陆续有多架包机抵达中国，为全国消费者带来“才下枝头就到舌尖”的新鲜体验。毅都常年与智利众多供应商合作，产地直采优质车厘子通过毅都冷链发往全国水果批发市场。在京东、天猫超市等线上渠道和连锁商超销售份额稳居前列。毅都提供线上线下的物流服务、金融服务、交易服务、贸易服务，并充分发挥自身现代化冷链物流优势赋能万亿级生鲜供应链市场发展。',
            ]
          }
        ]
      }
    },
    {
      h1:'毅都（东北冷鲜港）入选国家骨干冷链物流基地',
      date:'2022-10',
      day:'22',
      p:{
        //前言
        foreword: [
          '近日，国家发展改革委印发通知，发布2022年国家骨干冷链物流基地建设名单，由毅都（东北冷鲜港）牵头的沈阳国家骨干物流基地项目获得国家批准，成为辽宁省唯一入选企业。'
        ],
        //二级标题与内容
        secondArticle: [
          {
            image: [
              require('@/assets/images/news/2022/1022/image1.jpeg')
            ],
            text: [
              '“十四五”冷链物流发展规划要求，国家骨干冷链物流基地将有力支撑“四横四纵”通道网络建设，带动冷链物流规模化、集约化、组织化、网络化发展；具备良好存量冷链设施条件和较大冷链物流规模，有力保障大中城市冷链物流服务和生活物资需求；围绕农产品特色产区、进出口重要节点、食品加工产业聚集地冷链产业发展需要，加强冷链物流与现代农业、冷链产品加工、商贸流通等产业融合发展，有效扩大中高端冷链物流服务供给，支撑带动相关产业做大做强做优。促进枢纽互联成网，推动完善以枢纽为支撑的“轴辐式”物流服务体系。发挥枢纽优势促进大宗商品中长距离运输“公转铁”“公转水”，在更大范围、更深层次促进物流提质增效降本。加强工业园区、产业集群与枢纽布局衔接、联动发展，打造具有区域集聚辐射能力的产业集群，培育发展枢纽经济。发挥枢纽作用，优化物流大通道沿线产业布局与分工合作体系，打造经济和产业发展走廊。',

              '沈阳国家骨干冷链物流基地的成功获批，是对毅都深耕冷链物流领域、布局全国打造“覆盖全国统一标准的生鲜服务平台”的充分认可。未来，毅都将持续发挥带头作用，加大建设力度，构建海铁联运等冷链国际通道、铁路国内通道、区域辐射网络，支持区域农产品扩大辐射范围，促进农产品商贸流通。构建物流与关联产业融合发展生态，畅通生鲜农产品生产、流通、消费全链条一体化组织，争做示范型国家骨干冷链物流基地。'
            ]
          }
        ]
      }
    },
    {
      h1:'不忘初心，再攀新峰！东北冷鲜港水果交易市场正式开业！',
      date:'2022-05',
      day:'06',
      p:{
        //前言
        foreword: [
          '5月6日，沈阳市浑南区浑南东路298号的东北冷鲜港水果交易市场开业暨市场监督管理所挂牌仪式举行。这个被誉为目前东北地区最大的农产品冷链物流基础设施项目，将成为水果人的家，并且有着完善的防疫措施，确保沈阳乃至周边城市的老百姓能吃上安全、鲜美的水果。'
        ],
        //二级标题与内容
        secondArticle: [
          {
            image: [
              require('@/assets/images/news/2022/0506/image1.jpeg')
            ]
          },
          {
            title: '东北最大农产品冷链物流基础设施',
            text: [
              '该项目占地面积1100亩，由毅都集团斥资30亿元打造，是集果蔬恒温冷库、肉类水产冷冻库、常温分拣库和集散运输为一体的大型冷链物流枢纽设施，规划建设冷库面积70万平方米，冷库库容80万吨，拥有国际、国内一流的物流体系设计及相关配套设施，是目前东北地区最大的农产品冷链物流基础设施项目。东北冷鲜港是沈阳市定点首站冷库和东北地区首个肉类海关监管查验场，为保障东北地区农副产品的市场流通起到了不可替代的作用。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0506/image2.png')
            ]
          },
          {
            title: '承担保供沈阳人民“果盘子”重任',
            text: [
              '今年3月，东北冷鲜港为保障商贸流通，承接了保供沈阳人民“果盘子”的重任，在沈阳市发展和改革委员会、沈阳市市场监督管理局、沈阳市商务局、浑南区委和浑南区人民政府的大力支持下，东北冷鲜港响应迅速，立即将现有果蔬交易区20万平方米投入保供，实现了日均交易水果3000吨以上的目标，满足了沈阳市民日均水果交易2300吨的需求。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0506/image3.jpeg')
            ]
          },
          {
            title: '多措并举确保水果交易防疫安全',
            text: [
              '园区配套设施完善，为避免园区内车流交织，东北冷鲜港新建了缓冲区、配货区和停车场；为充分保障商户和采购人员的安全，东北冷鲜港在园区内建立了24小时核酸检测点位和消杀点位，配备了与盛事通对接的人脸识别系统。这些举措有力地保障了水果交易市场的良性发展和防疫安全。为了更好地促进沈阳市果品交易业态的发展，浑南区市场监督管理局正式在沈阳东北冷鲜港水果交易市场挂牌成立东北冷鲜港水果交易市场监督管理所，在全面规范市场秩序的同时，引导市场逐步走向规模化、专业化运营。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0506/image4.png')
            ]
          },
          {
            title: '以“水果小镇”模式适应不同季节需求',
            text: [
              '毅都集团将以本次东北冷鲜港水果交易市场挂牌为契机，在进一步满足沈阳地区水果交易市场需求的基础上，充分体现沈阳市在东北地区商贸流通领域的辐射支配地位，全面推进11-18号恒温水果冷库的扩建工程，全面投产后，将新增恒温冷库及其附属交易区36万平方米，可实现日交易量突破1万吨的目标，更好地解决沈阳地区生鲜农产品仓储和交易的供需矛盾，实现跨越式增长。',

              '同时，为了减少人员跨区域流动，加强从业人员主体管控，东北冷鲜港规划建设15万平方米的公寓和酒店，以“水果小镇”的模式适应不同季节常驻商户和流动商户的需求，实现有效管理。',

              '在仪式上，沈阳市浑南新区张鹰区长发表讲话，对毅都东北冷鲜港水果交易市场的启动表示祝贺，对毅都工作表示认可，并提出了新的期望。',
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0506/image5.png')
            ]
          },
          {
            text: [
              '毅都集团刘智总经理进行致辞，感谢沈阳市政府给予毅都东北冷鲜港水果交易市场的大力支持与帮助，感谢果业同行的信任与同事们的辛勤付出，并提出水果交易中心未来工作的郑重承诺，打造温暖市场，共创美好明天。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0506/image6.png')
            ]
          }
        ]
      }
    },
    {
      h1:'毅都直采智利车厘子，海陆联运抢“鲜”上市',
      date:'2022-02',
      day:'22',
      p:{
        //前言
        foreword: [
          '虎年春节前夕，各地水果市场一片红火，车厘子更是成为各档口不可缺少的颜值担当。在1月20日和22日，两艘由毅都集团委托承运，满载智利车厘子和油桃、蓝莓的散货船如期抵达大连大窑湾码头，实现抢“鲜”上市，保证了春节期间持续高品质供应。'
        ],
        //二级标题与内容
        secondArticle: [{
          title: '突破国际运输压力，实现车厘子抢“鲜”通关',
          text: [
            '由于全球疫情形势依然严峻，海运货柜不足、港口拥堵、船期延误，全国口岸清关物流成为了进口货物痛点。恰逢春节前夕进口船舶集中到港、港口卸货拥堵、口岸清关压力大、速度缓慢，口岸进口冷链货物积压严重，对于春节前热销品种的车厘子，面临清关运输时效的巨大挑战。在辽港集团、大连海关、大连市政府的支持下，为企业提供完善的口岸环境与科学的调度指导，为进口车厘子提供了周到便捷的一站式监管服务，创造了抢“鲜”通道。大窑湾海关高效监管作业，实现车厘子当天验放、快速通关。毅都团队与口岸办及辽港集团积极沟通，协作梳理了整体操作流程，提前制定作业方案与防疫操作培训，确保船舶作业安全有序，让车厘子“鲜上加快”。',

            '船舶到港经核酸检测、作业区域消毒后，第一时间集装箱车船直取，22点船舶靠泊，凌晨3点第一柜货顺利进入毅都四期场地。散货船所有货物整体消毒、海关查验放行后，入库至毅都四期水果库。毅都凭借多年的散货船进口经验及完善的冷链物流配套，有效压缩到港时间，确保生鲜高效顺畅通关、入库。'
          ]
        },
          {
            image: [
              require('@/assets/images/news/2022/0222/image1.jpeg')
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0222/image2.jpeg')
            ]
          },
          {
            title: '数字化赋能作业流程，提质增效保障品质',
            text: [
              '数字化赋能卸船全流程，展翼车卸货到月台，扫描托盘条码即可显示流向和查验状态；完成消杀、放行后，再次扫描托盘条码即可装车；真人语音播报当前板数，确保信息准确无误；点击发车按钮，自动触发海关单一窗口出库核销；卡口自动识别车号，出库报文发送到海关，后台校验数据，收到海关报文回执自动抬杆，形成海关监管场所数据全流程闭环管理。实时了解卸船、消杀、出库装车等各环节进度，全流程数据透明可视，有效提高作业效率。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0222/image3.jpeg')
            ]
          },
          {
            title: '丰富节日生鲜市场、确保食品安全',
            text: [
              '近年来，车厘子受到越来越多国内消费者的喜爱，已成为大家装点春节家宴、走亲访友最受欢迎的水果之一。毅都与智利众多供应商合作，严选生鲜源头，数量大、品种优、品质佳的车厘子通过毅都冷链发往国内北方一、二线城市，以及上海和广州的水果批发市场，供应全国十几个城市，口岸-配送-城市贯通一气。借助京东、天猫超市等渠道优势，通过线上平台及线下的永辉、7-fresh等门店，7天内近万吨新鲜水果销售一空，为千万家庭带去车厘子的幸福甜蜜味道。',

              '为确保消费者购物安心、食用放心，毅都将食品安全落实到各个环节，在消杀、储存、运输等环节都实施闭环管理，全程消杀，严格防疫，确保每箱车厘子来源可查、去向可追。经相关机构检测，送检的智利车厘子核酸检测结果均呈阴性。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2022/0222/image4.png')
            ]
          },
          {
            text: [
              '此次生鲜包船业务是毅都集团首次产地直采直达，由于全球疫情形势严峻，包船进口可能成为水果行业常态，毅都高效的管理团队，构建生鲜食品供应链优秀管理者的硬实力；不断完善供应链模式，为行业发展持续发力，让更多优质生鲜进入中国市场。',

              '毅都聚焦生鲜食品供应链服务，提供线上线下的物流服务、金融服务、交易服务、贸易服务，以分布在大连、沈阳、郑州、广州的港口冷库为基础，搭建临空、临港、内陆口岸全类型的冷链物流体系，形成覆盖全国的快捷、高效、低成本的冷链配送服务，为客户提供一站式冷链物流方案。毅都凭借多年经验与自主冷链优势，缓解疫情造成的跨境水果供应链困局，促进口岸活力释放，加速增量货源、开放发展，为国内生鲜市场发展与升级不断努力。'
            ]
          }
        ]
      }
    },
    {
      h1:'深化技术交流 促进校企合作——大连海事大学校长孙玉清一行到毅都冷链调研交流',
      date:'2021-10',
      day:'27',
      p:{
        //前言
        foreword: [
          '10月27日，大连海事大学校长孙玉清一行来到大连港毅都冷链有限公司进行装卸设备研发及人才培养工作探讨。调研过程中，孙玉清校长一行到毅都冷链一~五期项目进行了实地参观。'
        ],
        //二级标题与内容
        secondArticle: [{
          image: [
            require('@/assets/images/news/2021/1027/image1.jpeg')
          ],
          text: [
            '通过实地参观，孙玉清校长详细了解了毅都冷链的发展状况、项目规划、技术设备等情况。本次研讨会在此基础上，对冷链行业的现状、现有技术、对技术提升的需求及人才输送等方面进行了深入的交流探讨。',

            '孙玉清校长表示，大连海事大学高度重视人才培养，并积极探索创新培养模式，希望与企业携手，推进产学研用深度融合，力争实现关键技术突破，为行业建设贡献智慧力量。',

            '毅都冷链总经理刘智表示，多年来，毅都冷链坚持创新变革，正全力打造技术一流、信息畅通、政策匹配、面向国际的“一站式”冷链物流平台。',

            '当前，面对国际复杂的疫情防控形势，毅都集团积极求变，希望依托大连海事大学强大的科技研发能力和技术支持，与企业丰富的专业实践经验相融合，深化校企合作研发方案，发挥各自优势，形成强大合力，努力解决外贸冻鱼卸货作业等难题，携手推进冷链物流智能装卸、拣选、运输等技术装备研究，推进行业快速发展。',

            '针对目前冷链物流产业规模和发展潜力巨大，人才需求较大的现状，双方在产学研合作、教育教学资源建设、企业定制化人才培养、学生就业指导等领域进行了充分交流。希望结合学校的培养和企业提供的平台，为冷链物流行业补充更多的未来中坚力量，实现学校和企业，学术和行业的共赢。',

            '会议最后，双方共同表示，深化技术交流、促进校企合作是共同的愿景，希望通过产学研用深度合作的方式，将高新技术融合到企业实践中，切实解决产业发展难题，为冷链物流经济发展做出新的更大贡献。',
          ]
        }]
      }
    },
    {
      h1:'毅都集团与大连理工大学经济管理学院签署战略合作协议',
      date:'2021-9',
      day:'13',
      p:{
        //前言
        foreword: [
          '9月10日，大连理工大学经济管理学院院长朱方伟教授一行10人来到大连港毅都冷链有限公司进行校企合作对接与交流座谈。'
        ],
        //二级标题与内容
        secondArticle: [{
          image: [
            require('@/assets/images/news/2021/0913/image1.png')
          ],
          text: [
            '大连港毅都冷链总经理刘智对朱方伟院长一行表示热烈欢迎。刘智总经理介绍了毅都冷链的发展近况和发展规划。朱方伟院长介绍了经济管理学院的相关专业、校企合作案例。'
          ]
        },
          {
            image: [
              require('@/assets/images/news/2021/0913/image2.png'),
              require('@/assets/images/news/2021/0913/image3.png')
            ],
            text: [
              '在座谈会上，双方就合作方案进行了充分研讨，包括人才培养、实习实践基地建设、科研合作与发展咨询、企业案例采编等内容，在主要合作方向上达成了一致。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2021/0913/image4.png')
            ],
            text: [
              '研讨会后，毅都和大连理工大学经管学院的校企签署了全面战略合作协议。根据协议，双方将在平等合作、优势互补、互利双赢、共同发展的基础上，建立全面战略合作关系，积极探索产学研合作新模式，开展深度的校企合作。'
            ]
          },
          {
            image: [
              require('@/assets/images/news/2021/0913/image5.png')
            ],
            text: [
              '大连理工大学经济管理学院、运营管理研究所、智慧商务物流研究所、经济研究所、企业管理研究所等相关教授导师出席了签约仪式并交流分享对冷链物流行业看法和经验。'
            ]
          }
        ]
      }
    }
  ],

  //进出口贸易
  ImportAndExportTrade:{

    p1:'--主营生鲜经营业务，用严格的质量标准、专业化的经营团队，从全球采购优质农产品，生鲜销售网络覆盖全国；',

    p2:'--开展生态农业业务，引进国际优质生鲜种苗，带动农民就业增收。',

    title1:'产地直采',
    titleEn1:'Select From Source',

    p3:'毅都业务布局广阔，覆盖海外多个国家，包括智利、美国、南非、秘鲁、澳大利亚、菲律宾、加拿大、西班牙、厄瓜多尔、巴西等。与世界知名农产品公司建立长期良好的合作关系，与各供应商携手推广优质产品。',

    p4:'毅都进口水果品项包括提子、车厘子、蓝莓、苹果、核果、柑橘、热带果、奇异果、牛油果、香蕉等。',

    p5:'毅都进口肉类品项包括猪肉，牛肉，羊肉。',

    title2:'国内销售',
    titleEn2:'Domestic Sales',

    p6:'我们开拓了全渠道的营销网络，通过批发市场直营档口、超市促销、电商新零售（京东生鲜、七鲜超市、天猫超市、永辉超市、美团买菜等）渠道销售生鲜，同时，我们在大连、沈阳、北京、上海、广州等重要城市设置销售网点，实现生鲜市场覆盖全国。',

    p7:'拥有“毅都”“珍享”“奇奇”等生鲜品牌。',

    title3:'生态农业',
    titleEn3:'Ecological Agriculture',

    p8:'积极引进国际新品种、先进栽培技术、智能化采后处理设备和技术，逐步发展成集蓝莓、葡萄、樱桃等优质种苗的繁育、研发、授权种植、果实加工、销售、品牌运营一体化的全产业链模式。毅都正在全力打造品种先进、种源纯正、技术领先的一流现代化农业，为中国果业的升级做出不懈努力。',

    title4:'产品展示：',
    titleEn4:'Product Display',

    p9:'大连港毅都冷链致力于打造中国进口生鲜食品供应链最佳服务者，以大连、沈阳、郑州、广州、上海为建设基地，引入拥有优势港口资源的国有资本，打造多地联动、技术一流、信息畅通、政策匹配、对接国际标准的“一站式”冷链物流服务平台。',

  },

  //冷链物流
  ColdChainLogistics:{

    p1:'以规模化的冷链物流设施为基础，以功能完善的信息化平台为工具，以专业的冷链运营团队为核心，利用金融服务为杠杆，让生产者与消费者无缝连接，将自身打造成进口生鲜食品供应链最佳服务商。',

    title1:'水产冷链服务中心',
    titleEn1:'Seafood Cold Chian BU',

    p2:'发展目标',

    p3:'整合市场资源，利用保税港区政策优势，通过信息化手段，为国内外客户提供高效、专业、便捷的信息化保税仓储物流服务，成为国内第一大国际中转冷冻货物物流中心。',

    p4:'打造亚洲首家智能化仓储服务平台，为国内外客户提供更具市场竞争力的仓储物流服务。',

    p5:'服务特色',

    p6:'--位于大窑湾保税港区内，毗邻集装箱及散货渔船码头，享有保税港区政策优势及码头物流操作的便利性。',

    p7:'--总仓储能力4万吨，20个全封闭温控装卸平台，信息化仓储管理系统，确保出入库货物的作业效率和准确性。',

    p8:'--冷库采用液氨排管制冷，可保证季节性捕捞鱼获及冷冻原料的长期仓储品质。',

    p9:'--通过MSC和ASC国际认证，与俄罗斯、美国、加拿大、日本等各大水产品供应商达成了长期的冷冻大洋鱼获的保税仓储和国际中转合作。',

    p10:'--行业第一：年吞吐量24万吨，国际中转量10余万吨。',

    title2:'肉类服务中心',
    titleEn2:'Meat Service BU',

    p11:'发展目标',

    p12:'作为东北地区规模最大的冷链服务平台，未来将继续为客户提供集装箱堆存、提箱、查验服务及冷冻（藏）货物的存储服务，打造冷冻（藏）仓储服务平台中的品牌标杆。',

    p13:'服务特色',

    p14:'堆场：采用国际先进的大跨距轨道吊进行集装箱装卸作业；占地5.1万平方米，其中2.5万平方米为冷藏集装箱堆存场地，可同时为1500个冷藏集装箱供电制冷；2台40吨轨道场桥；车船直取"作业模式，提高通关速度和降低通关成本；智能化堆场信息系统、智能进出场卡口，可同步满足疏港（直取）、提箱、查验等多项作业。',

    p15:'查验："车船直取"作业模式，提高通关速度和降低通关成本；大连海关辖区内第一个在“232号新管理办法”下获批的“海关监督作业场所”；60个查验卸货通道，可同时满足60个货柜的查验、装卸。',

    p16:'仓储：2个单体内贸冷库，分为地上6层低温库、地下1层高温库，总存储能力12万吨，年吞吐量60万吨；冷库采用液氨排管制冷技术，配备自动化温控系统、封闭温控装卸平台，最大程度保证货物品质；3间大型大厅展示区，可展示冷冻水产品、冷冻肉类产品和保鲜果蔬产品。',

    title3:'水果交易中心',
    titleEn3:'Fruit Trading Service BU',

    p17:'发展目标',

    p18:'为口岸客户提供便捷、高效的香蕉拆提、交易、配送、运输服务，创建国内最大的生蕉行业交易场所。',

    p19:'服务特色',

    p20:'--青蕉储存库房25间，青蕉库存储量可达到350个集装箱；香蕉催熟库房223间，单间库房每天可以催熟1440箱香蕉，香蕉催熟及出库量数量可以每日可达到40柜集装箱；作业月台190个。',

    p21:'--采用新型气熏催熟技术：现代化制冷设备，智能导风系统，5天完成香蕉催熟出库，催熟的香蕉颜色鲜艳，口感甜糯、硬度好、耐储存。 ',

    p22:'--一站式服务：从码头查验到拆提时间最短，成本最低，年拆提量20000箱，交易量达42万吨。',

    p23:'--智能订单管理：客户通过智能APP实现订单式管理，一键生成催熟及配送订单，实时跟踪催熟状态及完成时间，智能化管控香蕉在库及在途动态。',

    p24:'--提供返箱的便利条件，我们与马士基、达飞、海丰等大型船公司签约长期合作。',

    p25:'--占地面积5.7万平，毗邻大窑湾集装箱码头，距离大窑湾高速5KM。',

    title4:'供应链服务中心：',
    titleEn4:'Supply chain services',

    p26:'发展目标',

    p27:'为客户提供专业的国际冷链物流整合服务，打造一站式冷链物流服务窗口，提供最高效率、最低成本的一体化物流解决方案。',

    p28:'服务特色',

    p29:'--提供优质便捷的仓储/配送代理、报关/报检代理、租船订舱代理等物流服务。',

    p30:'--拥有先进的物流操作系统。',

    p31:'--实时掌握货运行业前沿动向。',

    p32:'--已与MSK，CMA，SITC等达成场站服务协议，毅都拆箱的货物可以直接返到毅都场地，节省返箱、提箱费和返箱费。',

    title5:'运输业务中心',
    titleEn5:'Distribution services',

    p40:'发展目标',

    p41:'为客户提供专业、优质、快捷的冷藏集装箱运输服务，打造成为行业首选的冷藏运输服务商。',

    p42:'服务特色',

    p43:'--专业制冷运输车辆100余台，配有车载发动机组，运输全程制冷。',

    p44:'--GPS卫星定位系统、温度监控设备，运输途中的检测位置和温度。',

    p45:'--提供运输成本优化方案，满足不同客户需求。',

    p46:'--干线运输、城际运输，为进口商提供从码头运至终端客户的一站式服务。',

    title6:'冷藏箱技术服务',
    titleEn6:'Refrigerated box technical services',

    p47:'发展目标',

    p48:'为船公司提供最专业的冷藏集装箱制冷机组维修服务，打造大连口岸集堆存、PTI、维修技术于一体的专业冷藏集装箱服务。',

    p49:'服务特色',

    p50:'--占地面积7万平方米，总堆存能力8000TEU，设有重箱堆存区、查验区、空箱堆存区、PTI检验及维修区。',

    p51:'--专业冷藏集装箱专用制冷插座2100个。',

    p52:'--2台进口正面吊、1台进口堆高机、3台进口场桥，可同时为客户提供高效服务。',

    p53:'--与马士基、达飞、海丰等大型船公司签约合作，每年总操作空箱量约为62000TEU。',

    p54:'--是美国开利、美国冷王、日本大金及丹麦冷星在大连地区的授权技术服务中心。',

    title7:'供应链金融',
    titleEn7:'Supply chain financial services',

    p55:'发展目标',

    p56:'为客户提供金融解决方案，协助客户增加市场贸易份额，致力于打造国内规模最大的冷链行业供应链金融服务平台。',

    p57:'服务特色',

    p58:'--为冷链企业提供融资支持，解决客户资金难题，降低企业融资成本，实现财务优化。',

    p59:'--提供前T/T、后T/T、关税保函、结算等金融产品和组合服务。',

    p60:'--强化风险管控的基础上全面推进供应链金融服务，逐步发展成为冷链贸易服务核心运营商。',

    title8:'全国布局',
    titleEn8:'National Layouts',

    p61:'毅都冷链在大连、沈阳、郑州、广州建设冷鲜港，搭建临空、临港、内陆口岸联动的物流网络，形成高效率、低成本的信息化服务体系，为客户提供一站式冷链物流解决方案，打造覆盖全国统一标准的生鲜冷链服务平台。',

    p62:'大连港毅都冷链',

    p63:'--成立于2004年，现在是大连口岸地区最大的冷链物流企业。',

    p64:'--建立有46万吨冷库和世界最大香蕉加工库。',

    p65:'--搭建世界领先的临港生鲜产业服务一站式交易平台。',

    p66:'沈阳东北冷鲜港',

    p67:'--成立于2012年，致力于建设成为以大型冷链仓储服务为基础的国际贸易平台、冷链交易中心、冷链物流、配送交易中心及冷链产品的金融服务中心。',

    p68:'--在2012年和2014年度被评为“沈阳市重点建设项目”。',

    p69:'--在2022年获批国家骨干冷链物流基地。',

    p70:'郑州华中冷鲜港',

    p71:'致力于打造全国最大的空运进口生鲜集散地、全国最大的水果口岸，构筑面向中原经济区为主、辐射华中地区、以生鲜食品进口为特色的、以冷链物流为保障的、全球化食品进出口平台。',

    p72:'--距离新郑机场跑道80米，总占地面积为354亩。',

    p73:'--拥有国内规模最大的MAF光电自动分选线，高效完成进口水果的二次分包。',

    p74:'广州华南冷鲜港',

    p75:'--位于广州南沙，致力于打造成为华南区域品项最全的生鲜交易市场和贸易平台。',

    p76:'--目前处于规划、设计与施工阶段，未来对接中国最大的对外贸易口岸。'

  },

  //生态农业
  EcologicalAgricultures: {
    title1: '产业介绍',

    p1:'毅都农业是一家专业从事蓝莓、樱桃、葡萄、苹果等国际优良果树品种的种苗繁育、鲜果种植、销售及进出口业务的综合性现代化农业企业。目前已在云南、大连、丹东、新疆等地先后建立5个种植基地，总占地面积3000亩，达产后年产值近亿元。',

    p2:'公司以组培生物工程技术和智利ZEBRA公司的先进培育技术为依托，采用现代植物组培设备进行种苗生产，引进、应用和开发蓝莓、樱桃、葡萄、苹果等新品种和栽培新技术，在蓝莓、樱桃等的组织培养、种苗繁育、陆地栽培、保护地栽培以及防寒越冬等方面积累了丰富的经验。近年来，公司面向全国推广种植蓝莓5万余亩，范围涉及全国20多个省市及自治区。',

    p3:'基地依托集团优势，积极发挥龙头企业的带动作用，为农户提供产后处理、信息共享和产品销售服务，带动丹东、大连地区农户4500户，实现农户与市场的有效对接，初步形成了较为规范的生产、采后处理、销售一体化的格局。',

    title2: '基地概况',

    p4:'大连登沙河基地',

    p5:'大连登沙河基地投资近4000万元，露天蓝莓种植面积100亩，棚内全基质蓝莓种植面积20亩、樱桃20亩。拥有34个育苗大棚。',

    p6:'丹东宽甸&凤城基地',

    p7:'丹东宽甸基地占地面积110亩，拥有14个单体面积2亩的大棚，其中1号棚用于放苗，2-12号棚种植西梅，13、14号棚种植蓝莓。露地种植西梅树2万多棵。',

    p8:'丹东凤城基地占地面积360亩，露天种植12万棵蓝莓，主要栽种品种为杜克（90%)和蓝丰（10%）。',

    p9:'新疆基地',

    p10:'新疆基地规划投入500座大棚种植蓝莓，结合自身优势，引进优良品种，针对新疆实际气候土壤情况，采用全基质栽培全新模式，引导带动新疆农户种植、发展新疆蓝莓产业。新疆基地还建立了500亩示范园区用于种植樱桃、葡萄。目标3-5年内带领周围农户种植10000亩，每亩产值8-10万元，为广大农户带来致富新途径。',

    p11:'云南基地',

    p12:'云南基地目前以种植为主，育苗为辅。种植面积500亩，全部采用先进无土栽培模式。专业育苗场地20亩，年产优质苗木100万株。',

  },

  //校园招聘
  CampusRecruitment:{
    // section:'以规模化的冷链物流设施为基础，以功能完善的信息化平台为工具，以专业的冷链运营团队为核心，利用金融服务为杠杆，让生产者与消费者无缝连接，将自身打造成进口生鲜食品供应链最佳服务商。',

    // 管培生项目
    ManagementTrainee:{
      title:'管培生项目',
      titleEn:'Management Trainee Program',
      p:['毅都管培生项目历时24个月，致力于发掘培养公司未来的领导者。每位管培生都会经历系统的培训和不同业务方向岗位实践，并经历跨部门、跨业务板块的轮岗工作。',

         '在项目期间，管培生会面临竞争和挑战，也会得到很多跨部门合作的机会来自我成长、自我发展；在进行定制化的培训的同时，也会接受全面的人才发展评估。公司会为最具潜力、表现优异的管培生们提供初级管理职位。',

         '在2年的管培期中，管培生不仅可以在实际的工作岗位上发挥个人价值，还能在岗位上逐渐深入体验公司业务并为之做出贡献，还有机会参与到公司各类重要项目中。同时，管培生将有专门的带教导师，为职业发展保驾护航，与优秀的同事、导师一起共同成长。',]
    },


    // 岗位介绍
    positionsInformation :[{
      menu:'品项方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '园艺、', '农学优先'],
      address: ['北京', '上海', '广州'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.跟踪水果/肉类的到货信息，熟悉并了解品类、品牌、品质等信息',

        '2.收集水果/肉类当日市场行情及价格波动，水果/肉类质检并出具报告',

        '3.根据品质及行情综合分析判断并给出定价参考',

        '任职要求：不限专业；园艺类、食品类、农学、动科动医、国际贸易类等专业优先'],

    },{
      menu:'自营档口方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '园艺、', '市场营销优先'],
      address: ['北京', '上海', '广州'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.掌握当日市场行情，掌握水果/肉品类、品牌、品种、规格、品质等信息',

        '2.根据品项指导的定价，结合市场行情把控销售定价，与品项及时沟通',

        '3.针对大批发客户进行水果/肉自营档口销售，盘点库存，回款跟进等',

        '4.不断的开发优质客户，学习与掌握客户对水果/肉类各方面的需求',

        '任职要求：不限专业；园艺类、食品类、农学、动科动医、市场营销类等专业优先'],

    },{
      menu:'催熟品控方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '园艺、', '食品优先'],
      address: ['北京', '上海', '广州'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.负责青蕉或牛油果到货检测、验收及催熟工作',

        '2.监督和指导催熟工人加工入库和出库筛选',

        '3.跟踪检查催熟水果品质，并针对销售/需求情况调整加工计划',

        '任职要求：园艺类、食品类、农学；催熟相关专业优先'],

    },{
      menu:'终端方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '园艺、', '市场营销优先'],
      address: ['北京', '上海', '广州', '武汉'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.对接盒马、京东等终端渠道，统计和上报订货信息',

        '2.参与新渠道拓展，谈判',

        '3.针对渠道方要求进行采购、加工、安排配送，保证按时交货',

        '任职要求：不限专业；园艺类、食品类、农学、动科动医、市场营销类等专业优先'],

    },{
      menu:'国际事务方向',
      menuEn:'Fresh Produce Trading',
      specialty:['英语，', '国际经济与贸易，', '国际商务'],
      address: ['大连'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.跟踪海运空运等物流、单证、报关信息等，进口贸易全流程操作',

        '2.与海外供应商沟通并及时反馈市场信息，拓展及维护海外供应商关系',

        '任职要求：英语、西班牙语、国贸专业；英语六级或专八及以上'],

    },{
      menu:'农业基地方向',
      menuEn:'Fresh Produce Trading',
      specialty:['园艺、', '农学、', '市场营销优先'],
      address: ['大连', '丹东', '云南', '新疆'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.负责蓝莓、樱桃等进口苗木的育种组培',

        '2.温室及露地蓝莓、樱桃生产种植管理',

        '3.苗木和果实的推广等',

        '任职要求：不限专业；农学、园艺、市场营销等相关专业优先'],

    },{
      menu:'物流方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '物流相关优先'],
      address: ['大连', '沈阳', '广州', '郑州'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.负责海运、仓储、集装箱堆场、清关代理、加工、配送等与冷链物流相关的各环节工作',

        '2.协助部门经理对各模块工作进行管理',

        '3.参与全国其他物流基地筹建，承担各模块筹建负责人角色',

        '任职要求：不限专业；物流相关专业优先'],

    },{
      menu:'软件开发方向',
      menuEn:'Fresh Produce Trading',
      specialty:['计算机相关专业'],
      address: ['大连'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.与软件开发公司共同完成各类信息系统开发及运维工作',

        '2.协助部门经理对各模块工作进行管理',

        '3.参与全国其他物流基地筹建，承担各模块筹建负责人角色',

        '任职要求：计算机相关专业'],

    },{
      menu:'安全方向',
      menuEn:'Fresh Produce Trading',
      specialty:['环境工程、', '安全工程、', '消防工程相关'],
      address: ['大连'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.消防及生产安全、疫情防控、场地内特种车辆及机械安全管理',

        '2.环保认证档案建立及系统维护管理、相关手续及法律法规识别',

        '3.安全教育培训、安全管理制度修订等工作',

        '任职要求：环境工程、安全工程、消防工程相关专业'],

    },{
      menu:'市场方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '市场营销、', '物流相关'],
      address: ['大连', '沈阳'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.负责开发所在区域水果/肉类/水产销售及加工客户，为客户提供包括通关、仓储、加工、配送以及供应链金融一站式服务',

        '2.管理和维护原有客户关系以及客户间的长期战略合作计划',

        '3.为客户提供进口生鲜产品的冷链物流全链条的最优解决方案',

        '任职要求：不限专业，市场营销专业优先'],

    },{
      menu:'制冷与动力方向',
      menuEn:'Fresh Produce Trading',
      specialty:['制冷、', '电气、', '自动化相关'],
      address: ['大连', '沈阳', '郑州'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.负责集装箱冷藏机组的检测、维护与维修业务',

        '2.负责高温冷藏库自动化机组的维护、监控工作',

        '3.负责水果加工库机组的开发与维护工作',

        '4.参与设计、开发与冷链物流相关的设备；学习国际最新制冷领域的技术与设备发展趋势',

        '任职要求：制冷、自动化、电气、机电相关专业'],

    },{
      menu:'品控方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '食品、', '农学相关'],
      address: ['大连'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.协助加工中心负责人对水果加工工艺制定流程',

        '2.学习特殊气体加工水果的标准流程',

        '3.协助负责人对现场作业人员的管理工作',

        '4.协助开展香蕉客户预约与出库等工作',

        '任职要求：不限专业；食品、农学类相关专业优先'],

    },{
      menu:'金融方向',
      menuEn:'Fresh Produce Trading',
      specialty:['不限，', '金融、', '经济相关'],
      address: ['大连', '沈阳'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.配合业务团队为银行、核心企业（客户）、合作平台提供供应链融资产品解决方案',

        '2.主导需求分析及产品设计工作',

        '任职要求：不限专业；金融、经济、统计等相关专业'],

    },{
      menu:'财务方向',
      menuEn:'Fresh Produce Trading',
      specialty:['财务管理、', '会计学'],
      address: ['北京', '上海', '广州', '大连', '沈阳'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['1.财务凭证整理；现金收付',

        '2.银行结算；财务账目；税务管理等',

        '任职要求：财务管理、会计学专业'],

    },{
      menu:'人力资源方向',
      menuEn:'Fresh Produce Trading',
      specialty:['人力资源相关'],
      address: ['大连', '沈阳'],
      section:'招聘对象：2021年9月1日 - 2022年8月31日期间毕业的应届生 【中国大陆（内地）以毕业证为准，中国港澳台及海外地区以学位证为准',
      title:'岗位职责:',
      p:['协助完成人力资源各模块流程跟进，如招聘、培训、员工关系等',

        '任职要求：人力资源、行政相关专业；英语六级以上，口语沟通流利，擅长商务英语优先'],

    },],
    // 校招流程
    flowPath:{
      title1:'校招流程',
      titleEn1:'Campus Recruitment Process',
      content:[{
          src: require('@/assets/images/CampusRecruitmentProcess/1.png'),
          text: '投递简历'
       }, {
        src: require('@/assets/images/CampusRecruitmentProcess/2.png'),
        text: '初试'
      }, {
        src: require('@/assets/images/CampusRecruitmentProcess/3.png'),
        text: '线上测评'
      }, {
        src: require('@/assets/images/CampusRecruitmentProcess/4.png'),
        text: '线上/线下复试'
      }, {
        src: require('@/assets/images/CampusRecruitmentProcess/5.png'),
        text: 'offer发放'
      }, {
        src: require('@/assets/images/CampusRecruitmentProcess/6.png'),
        text: '签订三方'
      }],
    }
  }
}

export default cn



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js